import useIsDesktop from "@hooks/useIsDesktop"

import JobTimelineViewDesktopUnscheduledJobs from "./JobTimelineViewDesktopUnscheduledJobs"
import JobTimelineViewMobileUnscheduledJobs from "./JobTimelineViewMobileUnscheduledJobs"
import JobTimelineViewUnscheduledJobsWrapper from "./JobTimelineViewUnscheduledJobsWrapper"

export default function JobTimelineViewHorizontalUnscheduledJobs() {
    const isDesktop = useIsDesktop()

    return (
        <JobTimelineViewUnscheduledJobsWrapper>
            {isDesktop ? <JobTimelineViewDesktopUnscheduledJobs /> : <JobTimelineViewMobileUnscheduledJobs />}
        </JobTimelineViewUnscheduledJobsWrapper>
    )
}
